<template lang="pug">
v-container.pb-1.fluid
  v-snackbar(v-model="handleError" color="error")
    div {{ errorMessage }}
  v-snackbar(v-model="handleFinishError" color="error")
    div {{ finishErrorMessage }}
  loading-page(v-if="showLoading")
  v-stepper.mt-2.elevation-0.transparent.stepper-main-container(
    v-else
    v-model="onboardingStep"
    alt-labels
  )
    v-stepper-header.stepper-header.elevation-0
      v-stepper-step.mx-5.step-title-icon(step="1") 
      v-divider
      v-stepper-step.mx-5.step-title-icon(step="2") 

    v-stepper-items
      v-stepper-content(step="1" align-center)
        onboarding-step-1(@click:change="setStep") 
      v-stepper-content(step="2")
        onboarding-step-3(@click:change="setStep")
    v-container.pa-0
      v-layout.mb-3(row align-center justify-center)
        v-btn.action-btn.mx-5.text-capitalize.transparent(
          v-if="onboardingStep === 1"
          flat
          @click="onboardingStep++"
        )
          span Skip
          v-icon chevron_right
    a.transparent.font-weight-bold(flat color="primary" @click="goToDashboard") 
      | {{ bottomLinkLabel }}
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import OnboardingStep1 from '@/Onboarding/components/OnboardingStep1';
import OnboardingStep2 from '@/Onboarding/components/OnboardingStep2';
import OnboardingStep3 from '@/Onboarding/components/OnboardingStep3';
import LoadingPage from '@/Onboarding/components/LoadingPage';

export default {
  name: 'Onboarding',
  components: {
    OnboardingStep1,
    OnboardingStep2,
    OnboardingStep3,
    LoadingPage,
  },
  data() {
    return {
      onboardingStep: 1,
      showLoading: true,
    };
  },
  async mounted() {
    if (!this.user) {
      await this.getUser();
    }
    if (this.user && this.user.email_is_verified !== true) {
      return this.$router.push('/resend-verification-email' + window.location.hash);
    }

    await this.getUserOnboardingInformation();
    if (!this.onboardingFinished && this.userHasFeatureFlag('ab-testing-test')) {
      window.$cookies.set('ab-testing-contacts', 'step1', null);
      await this.finishOnboarding();
      return this.$router.push('/contacts' + window.location.hash);
    }
    if (this.onboardingFinished && !this.userHasFeatureFlag('entitlement-nylas-blocking')) {
      return this.$router.push('/dashboard' + window.location.hash);
    }

    this.showLoading = false;
  },
  watch: {
    user: {
      handler(value) {
        window.lwcrm = { me: value };
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('onboarding', [
      'error',
      'errorMessage',
      'finishError',
      'finishErrorMessage',
      'onboardingFinished',
    ]),
    ...mapState('userInformation', ['user']),
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
    handleError: {
      get() {
        return this.error;
      },
      set() {
        this.resetError();
      },
    },
    handleFinishError: {
      get() {
        return this.finishError;
      },
      set() {
        this.resetFinishError();
      },
    },
    bottomLinkLabel() {
      return this.onboardingStep === 3 ? 'Skip and take me to homepage' : 'Take me to homepage';
    },
  },
  methods: {
    ...mapMutations('onboarding', ['resetError', 'resetFinishError']),
    ...mapActions('onboarding', ['getUserOnboardingInformation', 'finishOnboarding']),
    ...mapActions('userInformation', ['getUser']),
    setStep(value) {
      this.onboardingStep = value;
    },
    async goToDashboard() {
      await this.finishOnboarding();
      this.$router.push('/dashboard' + window.location.hash);
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper-main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.stepper-header {
  width: 1400px;
}
.step-title-icon {
  transform: scale(1.2);
}
.stepper-title {
  font-size: 36px;
  font-weight: 500;
  line-height: 1.1;
  color: var(--v-primary-base);
}
.stepper-subtitle {
  font-size: 20px;
}
.content-card {
  cursor: pointer;
  border-radius: 10px;
  min-height: 310px;
  width: 300px;
  &--bigger {
    height: 400px;
  }
}
.content-card-container {
  height: 100%;
}
.content-card-header {
  min-height: 60px;
}
.content-card-subcontainer {
  min-height: 125px;
}
.card-title-container {
  display: flex;
  flex-direction: row;
  height: auto;
}
.card-checkbox {
  transform: scale(1.1);
}
.card-title {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 220px;
  &--xs {
    font-size: 18px;
    width: 250px;
  }
}
.csv-upload-icon {
  font-size: 80px;
}
.continue-btn {
  font-size: 20px;
}
.action-btn {
  font-size: 14px;
  margin-top: 0;
  color: var(--v-primary-lighten3);
}
</style>
